export default "__VITE_ASSET__2IZwyUJm__"